import React, { useEffect } from "react";
import { BiMenuAltLeft, BiWindowClose } from "react-icons/bi";
import { Button } from "../components/Button";
import { ComoFunciona } from "../components/ComoFunciona";
import { Drawer } from "../components/Drawer";
import { Duvidas } from "../components/Duvidas";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { ModalSubmit } from "../components/ModalSubmit";
import { OndeComprar } from "../components/OndeComprar";
import { Section2 } from "../components/Section2";
import { Section5 } from "../components/Section5";
import { Section6 } from "../components/Section6";
import { Section8 } from "../components/Section8";
import { useButtonsActions } from "../hooks/useButtonsActions";
import { useDrawer } from "../hooks/useDrawer";
import { useModalTicket } from "../hooks/useModalTicket";
import { IoCloseSharp } from "react-icons/io5";
import { Footer } from "../components/Footer";

const Nav = () => {
  const { handleNavigateToPages } = useButtonsActions();

  const { toggleDrawer, isDrawerOpen } = useDrawer();

  useEffect(() => {
    document
      .querySelectorAll<HTMLAnchorElement>(".anchorNavigation")
      .forEach((a) => {
        a.addEventListener("click", () => {
          isDrawerOpen && toggleDrawer();
        });
      });
  }, []);

  return (
    <nav>
      <a
        className="anchorNavigation"
        id="anchorHeaderComoFunciona"
        href="#comoFunciona"
      >
        COMO FUNCIONA
      </a>
      <a
        className="anchorNavigation"
        id="anchorHeaderOndeComprar"
        href="#ondeComprar"
      >
        ONDE COMPRAR
      </a>
      <a
        className="anchorNavigation"
        id="anchorHeaderTelevendas"
        href="#televendas"
      >
        TELEVENDAS
      </a>
      <a
        className="anchorNavigation"
        id="anchorHeaderImportante"
        href="#importante"
      >
        IMPORTANTE
      </a>
      <a className="anchorNavigation" id="anchorHeaderDuvidas" href="#duvidas">
        DÚVIDAS
      </a>
      <a className="anchorNavigation" id="anchorHeaderFaq" href="#faq">
        FAQ
      </a>
      <Button
        text="Ver lojas indicadas"
        onClick={handleNavigateToPages}
        id="lojasIndicadasHeader"
      />
    </nav>
  );
};

function Home() {
  const { isModalOpen } = useModalTicket();

  const { isDrawerOpen, toggleDrawer } = useDrawer();

  return (
    <>
      <Header>
        <button className="menu" onClick={toggleDrawer}>
          {isDrawerOpen ? (
            <IoCloseSharp size={24} />
          ) : (
            <BiMenuAltLeft size={24} />
          )}
        </button>

        {!isDrawerOpen && <Nav />}
      </Header>

      <Hero />

      <Section2 />

      <ComoFunciona />

      <OndeComprar />

      <Section5 />

      <Section6 />

      <Duvidas />

      <Section8 />

      <ModalSubmit isOpen={isModalOpen} />

      {isDrawerOpen && (
        <Drawer>
          <Nav />
        </Drawer>
      )}

      <Footer />
    </>
  );
}

export default Home;
